import { Phone, MessageSquare, Handshake, Building2, Heart, TrendingUp } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_PHONE_FORMATTED, OWNER_FIRST_NAME } from "@/lib/constants";
import { useT } from "@/lib/i18n";

export default function AboutJeffrey() {
    const { t } = useT();
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14" data-testid="about-jeffrey">
            <div className="grid lg:grid-cols-12 gap-8 items-start">
                <div className="lg:col-span-7">
                    <span className="chip"><Handshake className="w-3 h-3" /> {t("about_chip")}</span>
                    <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
                        {t("about_title_a")} <span className="accent-gradient-text">{t("about_title_b")}</span>
                    </h2>
                    <p className="mt-4 text-slate-300 leading-relaxed text-base sm:text-lg">
                        {t("about_body")}
                    </p>

                    <ul className="mt-6 space-y-3 text-sm sm:text-base">
                        {[
                            { Icon: Building2, k: "about_point_1" },
                            { Icon: TrendingUp, k: "about_point_2" },
                            { Icon: Heart, k: "about_point_3" },
                        ].map(({ Icon, k }) => (
                            <li key={k} className="flex items-start gap-3 text-slate-200">
                                <span className="mt-0.5 inline-flex items-center justify-center w-8 h-8 rounded-xl bg-emerald-500/15 border border-emerald-500/35 text-emerald-300 shrink-0">
                                    <Icon className="w-4 h-4" />
                                </span>
                                <span>{t(k)}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <a href={`tel:${BUSINESS_PHONE}`} className="btn-primary" data-testid="about-call-cta">
                            <Phone className="w-4 h-4" /> {t("cta_call_me")} {BUSINESS_PHONE_FORMATTED}
                        </a>
                        <a href={`sms:${BUSINESS_PHONE}?&body=Hi ${OWNER_FIRST_NAME}, tell me more`} className="btn-ghost" data-testid="about-text-cta">
                            <MessageSquare className="w-4 h-4" /> {t("cta_text_me")}
                        </a>
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div className="card-surface p-6 sm:p-7">
                        <div className="mono text-xs text-emerald-300 uppercase tracking-widest">{t("about_promise_chip")}</div>
                        <h3 className="mt-2 text-xl font-semibold text-white">{t("about_promise_title")}</h3>
                        <ul className="mt-4 space-y-2 text-sm text-slate-300">
                            {[
                                "about_promise_1",
                                "about_promise_2",
                                "about_promise_3",
                                "about_promise_4",
                            ].map((k) => (
                                <li key={k} className="flex items-start gap-2">
                                    <span className="w-5 h-5 mt-0.5 rounded-full bg-emerald-500/20 border border-emerald-500/40 inline-flex items-center justify-center text-emerald-300 text-xs">✓</span>
                                    {t(k)}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
